$.widget( "custom.catcomplete", $.ui.autocomplete, {
    _create: function() {
        this._super();
        this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
    },
    _renderMenu: function( ul, items ) {
      var that = this,
        currentCategory = "";
          $.each( items, function( index, item ) {
            var li;
            if ( item.category && item.category != currentCategory ) {
              ul.append( "<li class='ui-autocomplete-category'>" + item.category + "</li>" );
              currentCategory = item.category;
            }
            li = that._renderItemData( ul, item );
            if ( item.category ) {
              li.attr( "aria-label", item.category + " : " + item.label );
            }
        });
    },
    _renderItem: function (ul, item) {
        if(item.url) {
            return $( "<a href="+ item.url +"></a>" )
                    .data( "item.autocomplete", item )
                    .append( "<li><img src='" + item.img + "' />" + item.label.substring(0,50) + "</li>" )
                    .appendTo( ul );
        } else {
            return  $( "<li style='padding: 5px; border-radius: 0px;'><i>" + item.label.substring(0,50) + "</i></li>" )
                    .appendTo( ul );   
        }

    }
});

$( ".search-input").catcomplete({
    delay: 250,
    minLength: 3,
    source: $("form.navbar-search").data('autocomplete-url'),
    appendTo: $(".search-results"),
    open: function(event, ui) {
        $('ul.ui-autocomplete').css({
            width: '100%',
            'margin-top': '10px'
        });
    },
    search: function(a, b) {
        $('.search-icon').hide();
        $('.search-waiting').show();
    },
    response: function(a, b) {
        $('.search-icon').show();
        $('.search-waiting').hide();
        if (!b.content.length) {
            var noResult = { url:0 ,label:"<i>Aucun résultat</i>" };
            b.content.push(noResult);
        }
    },

});
